<template>
  <v-btn @click="toggleSidebar" flat>
    <v-icon>info</v-icon>
    <span class="ml-2">Ejemplos</span>
  </v-btn>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapState } = createNamespacedHelpers("classifier");

export default {
  computed: {
    ...mapState(["show"])
  },
  methods: {
    ...mapMutations(["setShowSamplesSidebar"]),
    toggleSidebar() {
      this.setShowSamplesSidebar(!this.showSamplesSidebar);
    }
  }
};
</script>